"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PageTypes;
(function (PageTypes) {
    PageTypes[PageTypes["Login"] = 0] = "Login";
    PageTypes[PageTypes["EventList"] = 1] = "EventList";
    PageTypes[PageTypes["UserList"] = 2] = "UserList";
    PageTypes[PageTypes["CustomerList"] = 3] = "CustomerList";
    PageTypes[PageTypes["CustomerDetail"] = 4] = "CustomerDetail";
    PageTypes[PageTypes["RequestPasswordReset"] = 5] = "RequestPasswordReset";
    PageTypes[PageTypes["PasswordResetRequestText"] = 6] = "PasswordResetRequestText";
    PageTypes[PageTypes["ResetPassword"] = 7] = "ResetPassword";
    PageTypes[PageTypes["UserDetail"] = 8] = "UserDetail";
    PageTypes[PageTypes["RequestAccess"] = 9] = "RequestAccess";
    PageTypes[PageTypes["CompleteAccessRequest"] = 10] = "CompleteAccessRequest";
    PageTypes[PageTypes["EventLanding"] = 11] = "EventLanding";
    PageTypes[PageTypes["History"] = 12] = "History";
    PageTypes[PageTypes["VendorUserList"] = 13] = "VendorUserList";
    PageTypes[PageTypes["VendorUserDetail"] = 14] = "VendorUserDetail";
    PageTypes[PageTypes["EventConfiguration"] = 15] = "EventConfiguration";
    PageTypes[PageTypes["UserProfile"] = 16] = "UserProfile";
    PageTypes[PageTypes["NewEvent"] = 17] = "NewEvent";
    PageTypes[PageTypes["InventoryList"] = 18] = "InventoryList";
    PageTypes[PageTypes["InventoryDetailPage"] = 19] = "InventoryDetailPage";
    PageTypes[PageTypes["UserGroupList"] = 20] = "UserGroupList";
    PageTypes[PageTypes["UserGroupDetail"] = 21] = "UserGroupDetail";
    PageTypes[PageTypes["InventorySchedulerPage"] = 22] = "InventorySchedulerPage";
    PageTypes[PageTypes["EventOverviewReport"] = 23] = "EventOverviewReport";
    PageTypes[PageTypes["InventoryForecast"] = 24] = "InventoryForecast";
    PageTypes[PageTypes["SystemSettings"] = 25] = "SystemSettings";
    PageTypes[PageTypes["EventHistory"] = 26] = "EventHistory";
    PageTypes[PageTypes["CustomerCompanyList"] = 27] = "CustomerCompanyList";
    PageTypes[PageTypes["CustomerCompanyDetail"] = 28] = "CustomerCompanyDetail";
    PageTypes[PageTypes["VendorCompaniesPage"] = 29] = "VendorCompaniesPage";
    PageTypes[PageTypes["VendorCompanyDetailPage"] = 30] = "VendorCompanyDetailPage";
    PageTypes[PageTypes["AttendeeReport"] = 31] = "AttendeeReport";
    PageTypes[PageTypes["AttendeeBoldReport"] = 32] = "AttendeeBoldReport";
    PageTypes[PageTypes["MeetingsReportPage"] = 33] = "MeetingsReportPage";
    PageTypes[PageTypes["MeetingsBoldReportPage"] = 34] = "MeetingsBoldReportPage";
    PageTypes[PageTypes["TenantList"] = 35] = "TenantList";
    PageTypes[PageTypes["TenantDetailPage"] = 36] = "TenantDetailPage";
    PageTypes[PageTypes["HotelReportPage"] = 37] = "HotelReportPage";
    PageTypes[PageTypes["TransportationReportPage"] = 38] = "TransportationReportPage";
    PageTypes[PageTypes["VendorUserProfile"] = 39] = "VendorUserProfile";
    PageTypes[PageTypes["VendorEventList"] = 40] = "VendorEventList";
    PageTypes[PageTypes["VendorEmailTemplates"] = 41] = "VendorEmailTemplates";
    PageTypes[PageTypes["VendorEmailTemplate"] = 42] = "VendorEmailTemplate";
    PageTypes[PageTypes["VendorEventLandingPage"] = 43] = "VendorEventLandingPage";
    PageTypes[PageTypes["UrlAssignerPage"] = 44] = "UrlAssignerPage";
    PageTypes[PageTypes["MeetingPlacard"] = 45] = "MeetingPlacard";
    PageTypes[PageTypes["RoomDisplayPage"] = 46] = "RoomDisplayPage";
    PageTypes[PageTypes["AttendeeDataGridReport"] = 47] = "AttendeeDataGridReport";
    PageTypes[PageTypes["VenueDataGridReport"] = 48] = "VenueDataGridReport";
    PageTypes[PageTypes["EmailTemplates"] = 49] = "EmailTemplates";
    PageTypes[PageTypes["EmailTemplate"] = 50] = "EmailTemplate";
    PageTypes[PageTypes["VendorCompanyInfo"] = 51] = "VendorCompanyInfo";
    PageTypes[PageTypes["GolfCartReport"] = 52] = "GolfCartReport";
    PageTypes[PageTypes["DiningReport"] = 53] = "DiningReport";
    PageTypes[PageTypes["NamePlateReport"] = 54] = "NamePlateReport";
    PageTypes[PageTypes["HelpUrls"] = 55] = "HelpUrls";
    PageTypes[PageTypes["DeviceRegistration"] = 56] = "DeviceRegistration";
    PageTypes[PageTypes["SsoLogin"] = 57] = "SsoLogin";
    PageTypes[PageTypes["AllMeetingsList"] = 58] = "AllMeetingsList";
    PageTypes[PageTypes["MeetingNotesReportPage"] = 59] = "MeetingNotesReportPage";
    PageTypes[PageTypes["BoldReportsReportViewer"] = 60] = "BoldReportsReportViewer";
    PageTypes[PageTypes["DayPassReport"] = 61] = "DayPassReport";
    //<NEXT>
})(PageTypes || (PageTypes = {}));
exports.default = PageTypes;
